import { Route } from '../Routing/types';
import { TrackerPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/tracker/*',
    element: <TrackerPage descendantRoutes={descendantRoutes} />,
    private: true,
    title: dummy_t('tracker.details.navbarTitle'),
    mobileAppTabIdentifier: '',
    descendantRoutes,
  },
];

export default routes;
